import React from 'react';
import { stats, testimonials } from '../data/unstuckContent';
type TestimonialsSectionProps = {
  /** The first appearance carries the statistics strip. */
  variant?: 'primary' | 'compact';
  id?: string;
};
export function TestimonialsSection({
  variant = 'primary',
  id = 'proof'
}: TestimonialsSectionProps) {
  const isPrimary = variant === 'primary';
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby={`${id}-title`} data-id="element-212" data-mp="1qz9kn7r0uzqp">
      <div className="mx-auto max-w-6xl px-5" data-id="element-213" data-mp="1d47dyiecp6cu">
        <h2 id={`${id}-title`} className="sr-only" data-id="element-214" data-mp="1i1z3j5riwgdv">
          What people are saying about UNSTUCK
        </h2>

        {isPrimary && <dl className="grid grid-cols-2 gap-y-6 border-b border-charcoal-600 pb-10 sm:grid-cols-4" data-id="element-215" data-mp="1439b43fnf4vu">
            {stats.map(s => <div key={s.label} className="text-center" data-id="element-216" data-mp="2yeo18lckn6c4">
                <dd className="font-display text-2xl font-semibold text-champagne sm:text-3xl" data-id="element-217" data-mp="2yd336lr1t59i">
                  {s.value}
                </dd>
                <dt className="mx-auto mt-1 max-w-[8rem] text-[9px] font-medium uppercase tracking-[0.16em] text-muted sm:text-[10px]" data-id="element-218" data-mp="2v0sv1a21463w">
                  {s.label}
                </dt>
              </div>)}
          </dl>}

        <ul className={`grid gap-3 sm:grid-cols-3 ${isPrimary ? 'mt-10' : ''}`} data-id="element-219" data-mp="34qm5u8uckh73">
          {testimonials.map(t => <li key={t.name} className="flex flex-col border border-charcoal-600 bg-charcoal-800 p-5" data-id="element-220" data-mp="2zuncs7y2qb0c">
              <div className="flex items-center gap-3" data-id="element-221" data-mp="274oucvedxc4n">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-champagne/40 text-[11px] font-semibold tracking-[0.08em] text-champagne" aria-hidden="true" data-id="element-222" data-mp="275ztuj0srxpy">
                  {t.initials}
                </span>
                <span className="text-[10px] tracking-[0.2em] text-champagne" aria-label="5 out of 5 stars" data-id="element-223" data-mp="3sh8eo2c6e5i5">
                  ★★★★★
                </span>
              </div>
              <blockquote className="mt-3.5 text-[13px] leading-relaxed text-ivory-100" data-id="element-224" data-mp="8d2c00zbzo5b">
                “{t.quote}”
              </blockquote>
              <footer className="mt-auto pt-4 text-[9px] font-medium uppercase tracking-[0.16em] text-muted" data-id="element-225" data-mp="davhsswq2g52">
                {t.name}
                <span className="ml-2 text-ivory-300" data-id="element-226" data-mp="3gu6zeoiemnhp">{t.role}</span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}